import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { observable } from 'mobx'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import VersionPage from '../components/VersionPage'
import MessageHistory from '../../message/containers/MessageHistory'
import Loader from '../../shared/components/Loader'

import syncTransaction from '../../shared/syncTransaction'

@inject('museum', 'program', 'guidedTour', 'release') @observer
class VersionsContainer extends Component {

  /* eslint-disable react/sort-comp */
  @observable isSaving = null

  @observable error = null
  /* eslint-enable react/sort-comp */

  static propTypes = {
    guidedTour: PropTypes.object,
    museum: PropTypes.object,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    }),
    program: PropTypes.object,
    release: PropTypes.object,
    router: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  }

  componentWillMount() {
    const { params: { type, id } } = this.props
    const store = this.props[type]
    const typeId = id.substr(1) * 1

    if (!store.getById(typeId)) {
      store.load(typeId)
    }
    store.load(typeId, { params: { version: 1 } })
  }

  @autobind
  handleClose() {
    // On close go back to startpage as defined in #65
    this.props.router.push('/')
  }

  @autobind
  handleReject({ target, message }) {
    return this::syncTransaction(this.props.release.reject(target, {
      rejectionMessage: message
    }))
  }

  @autobind
  handleRelease({ target }) {
    return this::syncTransaction(this.props.release.release(target))
  }

  @autobind
  handleDelete({ target }) {
    return this::syncTransaction(this.props.release.delete(target))
  }

  render() {

    const { params: { type, id } } = this.props
    const store = this.props[type]
    const typeId = id.substr(1) * 1
    const draft = store.getById(typeId)
    const version = store.collection.find((itm) => itm.versionRefId * 1 === typeId)

    if (!draft) {
      return <Loader>Laden...</Loader>
    }

    return (
      <div className="horizontal">
        <VersionPage
          version={version}
          draft={draft}
          onClose={this.handleClose}
          onDelete={this.handleDelete}
          onReject={this.handleReject}
          onSave={this.handleRelease}
          isBusy={this.isSaving}
        />
        {id
          ? (
            <MessageHistory
              type={type}
              id={typeId * 1}
            />
          )
          : null}
      </div>
    )
  }

}

const VersionsContainerWithRouter = withRouter(VersionsContainer)

export { VersionsContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/release/containers/Versions.js